
var React = require("react");
var ActionButton = require("../generic/ActionButton.jsx");
var DataActionUtil = require("../../../util/DataActionUtil.js");

class ExportStepButton extends React.Component  {
    constructor(){
        super()
    }

    render(){
       
        return <ActionButton 
                    {...this.props}
                    text="Export OBJ"
                    mainClass=""
                    action={DataActionUtil.exportOBJ}
               />
    }
}

module.exports = ExportStepButton;